import { useNavigate } from 'react-router-dom';
import TopBar from '../../components/TopBar';

const items = [
  { to: '/admin/cinemas', title: 'Кинотеатры', desc: 'Список и схемы залов' },
  { to: '/admin/sessions', title: 'Сеансы', desc: 'Афиша и цены' },
  { to: '/admin/tickets', title: 'Билеты', desc: 'Заказы и возвраты' },
  { to: '/admin/scanner', title: 'Сканер QR', desc: 'Гашение на входе' },
  { to: '/admin/broadcast', title: 'Рассылки', desc: 'Сообщения всем' },
  { to: '/admin/banners', title: 'Баннеры', desc: 'Главная карусель' },
  { to: '/admin/payment-cards', title: 'Карты для оплаты', desc: 'Реквизиты для приёма платежей' },
];

export default function AdminHome() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen pb-8">
      <TopBar title="Админка" />
      <div className="px-4 pt-3 grid grid-cols-1 gap-2.5">
        {items.map((i) => (
          <button
            key={i.to}
            onClick={() => navigate(i.to)}
            className="card p-4 text-left active:opacity-90"
          >
            <div className="font-semibold">{i.title}</div>
            <div className="text-xs text-muted mt-0.5">{i.desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
